import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import produce from "immer";

export const requestStatusEnum = {
  RR:"REQUEST_RECIEVED",
  IP:"IN_PROGRESS",
  S:"SUCCESS",
  F:"FAILED"
}

const updateContent = (content, type, element) => {
  if(type === 'section') return content
  let playlist = JSON.parse(content.playlist)
  if (type === 'video') {
    playlist.push([element.id, playlist.length, 0])
    content.videos.push(element)
  } else if(type === 'quiz'){
    // Handle nested quiz response structure: {quiz: {...}, msg: {...}}
    const quizElement = element.quiz || element
    playlist.push([quizElement.id, playlist.length, 1])
    content.quizzes.push(quizElement)
  } else if (type === 'document') {
    playlist.push([element.id, playlist.length, 2])
    content.pages.push(element)
  } else if (type === 'url') {
    playlist.push([element.id, playlist.length, 3])
    content.urls.push(element)
  }
  content.playlist = JSON.stringify(playlist)
  return content
}

// export default function instructorCourseGCReducer(state = initialiS)

export default function instructorCourseGCReducer(
  state = InitialState.instructorCourseGC,
  action
) {
  //log.log("ACTION");
  //log.log(action);
  switch (action.type) {
    case types.LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS: {
      let { courseid, groups } = action;
      return produce(state, (draftState) => {
        draftState.instructorCourseGroupsMap[courseid] = groups;
        return draftState;
      });
    }

    case types.LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE:
      return state;
    case types.PUBLISH_INSTRUCTOR_CHAPTER_SUCCESS: {
      let { courseId, chapterId } = action;
      return produce(state, (draftState) => {
        const group = draftState.instructorCourseGroupsMap[courseId]?.find(
          (g) => g.id === chapterId
        );
        if (group) group.is_published = !group.is_published;
      });
    }
    case types.ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS: {
      let { courseid, group } = action;
      return produce(state, (draftState) => {
        draftState.instructorCourseGroupsMap[courseid].push(group);
      });
      // let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
      // instructorCourseGroupsMap.get(courseid).push(group);
      // return {
      //     ...state,
      //     instructorCourseGroupsMap
      // };
    }

    case types.DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS: {
      let { courseid, groupid } = action;
      return produce(state, (draftState) => {
        // log.log(courseid, groupid);
        // log.log(draftState);
        // log.log(draftState.instructorCourseGroupsMap[courseid]);
        // delete draftState.instructorCourseGroupsMap[courseid];
        draftState.instructorCourseGroupsMap[courseid] =
          state.instructorCourseGroupsMap[courseid].filter(
            (group) => group.id !== groupid
          );
      });
    }

    case types.EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS: {
      let { courseid, groupid, data } = action;
      return produce(state, (draftState) => {
        draftState.instructorCourseGroupsMap[courseid].map((item) => {
          if (item.id === groupid) {
            // (item.title = data.title), (item.description = data.description); //MISSING //TODO: This was giving an error: Expected an assignment or function call and instead saw an expression
            item.title = data.title;
            item.description = data.description;
            return item;
          }
          return item;
        });
      });
    }

    case types.LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
      let { groupid, concepts } = action;
      // log.log(action);
      return produce(state, (draftState) => {
        draftState.instructorGroupConceptsMap[groupid] = concepts;
      });
    // let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap)
    // instructorGroupConceptsMap.set(groupid, concepts);
    // return {
    //     ...state,
    //     instructorGroupConceptsMap
    // }

    case types.LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE:
      return state;

    case types.DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: {
      let { groupid, conceptid } = action;
      return produce(state, (draftState) => {
        // log.log(groupid, conceptid);
        // log.log(draftState);
        draftState.instructorGroupConceptsMap[groupid] =
          state.instructorGroupConceptsMap[groupid]?.filter?.(
            (concept) => concept.id !== conceptid
          );
      });
      // let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
      // let arr = instructorGroupConceptsMap.get(groupid).filter(concept => {
      //     return concept.id !== conceptid;
      // });

      // instructorGroupConceptsMap.set(groupid, arr);

      // return {
      //     ...state,
      //     instructorGroupConceptsMap
      // };
    }

    case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_REQUEST: {
      return {
        ...state,
        status: requestStatusEnum.RR,
        progress: 0.00
      }
    }

    case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_PROGRESS: {
      const progressEvent = action.payload;
      let progress = "uploading..."
      
      if (progressEvent.loaded && progressEvent.total) {
        const { loaded, total } = progressEvent
        // log.log({ "Hello": { progressEvent, loaded, total } });
        // progress = ((loaded / total) * 100).toFixed(2);
        // progress += "%";
        progress = loaded / total;
      }
      // log.log({hello:progress})

      return {
        ...state,
        status: requestStatusEnum.IP,
        progress: progress
      }
    }

    case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: {
      let { groupid, type, content, element } = action.payload;
      return produce(state, (draftState) => {
        const updatedContent = updateContent(content, type, element)
        draftState.instructorGroupConceptsMap[groupid].push(updatedContent);
        draftState.status = requestStatusEnum.S
      });

      // let { data, groupid } = action;
      // let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
      // let arr = [...instructorGroupConceptsMap.get(groupid)]
      // arr.push(data);
      // instructorGroupConceptsMap.set(groupid, arr);

      // return {
      //     ...state,
      //     instructorGroupConceptsMap
      // };
    }
    case types.INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS : {
      let {groupId, conceptId, data} = action.payload;
      return produce( state, (draftState) => {
        const index = draftState.instructorGroupConceptsMap[groupId].findIndex(item => item.id === conceptId);
        if(index !== -1) draftState.instructorGroupConceptsMap[groupId][index] = data;
      });
    }

    case types.EDIT_INSTRUCTOR_CHAPTER_CONTENTS_REQUEST: {
      const {chapterID, content} = action.payload
      return produce( state, (draftState) => {
        const index = draftState.instructorGroupConceptsMap[chapterID].findIndex(item => item.id === content.id);
        if(index !== -1) draftState.instructorGroupConceptsMap[chapterID][index] = content;
      });
    }

    case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE: {
      return {
        ...state,
        loading: requestStatusEnum.F
      }
    }

    case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_RESET: {
      return {
        ...state,
        progress: null,
        status: null
      }
    }

    case types.PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: {
      let { conceptid, groupid } = action;
      return produce(state, (draftState) => {
        let newConcepts = draftState.instructorGroupConceptsMap[groupid].map(
          (concept) => {
            if (concept.id === conceptid) {
              return {
                ...concept,
                is_published: !concept.is_published,
              };
            } else {
              return concept;
            }
          }
        );
        draftState.instructorGroupConceptsMap[groupid] = newConcepts;

        return draftState;
      });
    }

    case types.REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS: {
      let { courseid, groups } = action;
      // let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
      return produce(state, (draftState) => {
        draftState.instructorCourseGroupsMap[courseid] = [...groups];
        return draftState;
      });
    }

    case types.REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS: {
      let { groupid, concepts } = action;
      // let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
      return produce(state, (draftState) => {
        draftState.instructorGroupConceptsMap[groupid]= [...concepts]
        return draftState
      });
    }

    default:
      return state;
  }
}
